export default __webpack_public_path__ + "static/media/smiley-bk.a2c22c09.png";